'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight, PartyPopper, Package, Sparkles } from 'lucide-react';
const perks = [{
  icon: Package,
  text: 'Free or discounted product delivered to your door'
}, {
  icon: PartyPopper,
  text: 'Perfect for parties, launches & community events'
}, {
  icon: Sparkles,
  text: 'Brands want real people to try their stuff'
}];
export function FreeProductForEventsSection() {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">Get free or discounted product for your next event</h2>;
    t1 = <p className="text-lg text-gray-500 mb-10 max-w-xl mx-auto">Hosting a gathering, launch, or community event? Brands are looking for the perfect moment to get their products into people's hands — and your event could be it.</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">{perks.map(_temp)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="py-16 lg:py-16"><div className="container mx-auto px-4 sm:px-6 lg:px-8"><div className="max-w-3xl mx-auto text-center">{t0}{t1}{t2}<div className="text-center mt-12"><Link href="/for-events" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-emerald-600 text-white font-semibold shadow-md hover:bg-emerald-700 hover:shadow-lg transition-all duration-200 cursor-pointer">Get product for your event<ArrowRight className="h-4 w-4" /></Link></div></div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(perk) {
  return <div key={perk.text} className="flex items-center gap-2 text-gray-700"><perk.icon className="h-5 w-5 text-emerald-600 flex-shrink-0" /><span className="text-sm font-medium">{perk.text}</span></div>;
}